import React from 'react';
import * as yup from 'yup';
import createValidation from 'yup/lib/util/createValidation';
import SelectField from '../../../../../../../../Common/Forms/Fields/SelectField';
import { dateTimePicker } from '../../../../../../../../Modals/AddProjectModal/fields';

export const closeOrderFields = [
  {
    name: 'tokenToReceiveSymbol',
    id: 'Amount',
    className: 'w-50 fill-at-mobile',
    label: 'vpool.token_to_receive_symbol',
    placeholder: 'BNB',
  },
  {
    name: 'totalTokensToBeReceived',
    id: 'totalTokensToBeReceived',
    className: 'w-50 fill-at-mobile',
    label: 'vpool.total_tokens_to_receive',
    tag: 'number',
    placeholder: 0,
  },
  {
    name: 'amountOfTokensToReceiveNow',
    id: 'amountOfTokensToReceiveNow',
    className: 'w-50 fill-at-mobile',
    label: 'vpool.amount_to_deposit',
    tag: 'number',
    placeholder: 0,
  },
  {
    name: 'finalTokenPrice',
    id: 'finalTokenPrice',
    className: 'w-50 fill-at-mobile',
    label: 'vpool.final_token_price',
    tag: 'number',
    placeholder: 0,
  },
  {
    name: 'public_price',
    id: 'public_price',
    className: 'w-100 fill-at-mobile',
    label: 'vpool.public_token_price',
    tag: 'number',
    placeholder: 0,
  },
  {
    name: 'chain_of_origin',
    id: 'chain_of_origin',
    className: 'w-50 fill-at-mobile',
    label: 'vpool.chain_of_origin',
    renderField: ({ values, setValues }) => (
      <>
        <SelectField
          placeholder={values?.['chain_of_origin']}
          onChange={(option) => setValues({ ...values, chain_of_origin: option.value })}
          options={[
            {
              value: 'BSC',
              label: 'BSC',
            },
            {
              value: 'Ethereum',
              label: 'Ethereum',
            },
          ]}
        />
      </>
    ),
  },
  {
    name: 'tokenAddress',
    id: 'tokenAddress',
    className: 'w-50 fill-at-mobile',
    label: 'vpool.token_address',
  },
  {
    name: 'master_address',
    id: 'master_address',
    className: 'w-50 fill-at-mobile',
    label: 'vpool.master_address',
  },
  {
    name: 'lp_address',
    id: 'lp_address',
    className: 'w-50 fill-at-mobile',
    label: 'vpool.lp_address',
    infoHint: "Make sure the LP you're providing pairs your token with a stablecoin",
  },
  // {
  //   name: 'numberOfPortions',
  //   id: 'numberOfPortions',
  //   className: 'w-50 fill-at-mobile',
  //   label: 'vpool.number_of_portions',
  //   tag: 'number',
  //   placeholder: 0,
  // },
  {
    name: 'end_of_cliff',
    id: 'end_of_cliff',
    className: 'w-50 fill-at-mobile',
    label: 'vpool.end_of_cliff',
    // placeholder: Math.floor(Date.now() / 1000),
    renderField: dateTimePicker,
  },
  {
    name: 'end_of_vesting',
    id: 'end_of_vesting',
    className: 'w-50 fill-at-mobile',
    label: 'vpool.end_of_vesting',
    // placeholder: Math.floor(Date.now() / 1000),
    renderField: dateTimePicker,
  },
];

export const closeOrderValidationSchema = createValidation({
  totalTokensToBeReceived: yup.string().required(' '),
  champion_price: yup.string().required(' '),
  public_price: yup.string().required(' '),
  end_of_cliff: yup.mixed().test('len', 'Invalid timestamp', (val) => `${val}`?.length === 10 || !+val || val === null), // allow zero value since it's the default from BE side
  end_of_vesting: yup
    .mixed()
    .test('len', 'Invalid timestamp', (val) => `${val}`?.length === 10 || !+val || val === null),
  amountOfTokensToReceiveNow: yup.string().required(' '),

  lp_address: yup
    .string()
    .required(' ')
    .min(42, 'Invalid Token address')
    .max(42, 'Invalid Token address')
    .required(' '),

  tokenAddress: yup
    .string()
    .required(' ')
    .min(42, 'Invalid Token address')
    .max(42, 'Invalid Token address')
    .required(' '),

  master_address: yup
    .string()
    .required(' ')
    .min(42, 'Invalid Token address')
    .max(42, 'Invalid Token address')
    .required(' '),
});
